class FixedFiltersDirective {
    constructor($window, $document, $timeout, $rootScope) {
        this.restrict = 'A';
        this.$window = $window;
        this.$document = $document;
        this.$timeout = $timeout;
        this.$rootScope = $rootScope;
        this.headerPosition = 'static';
        this.isFixed = false;
        this.isTransition = false;
        this.showFilters = false;
    }

    link(scope, element, attrs, controllers) {
        let wrapper = element.children();
        let button = angular.element(wrapper.children()[1]);
        let timeoutPromise = null;

        this.$rootScope.$on('onHeaderToFixedComplete', (event, message) => {
            this.headerPosition = 'fixed';
            wrapper.css({'top': `${message.headerHeight}px`});
        });
        this.$rootScope.$on('onHeaderToStaticInit', (event, message) => {
            this.headerPosition = 'static';
            wrapper.css({'top': '0'});
        });

        button.on('click', (event) => {
            this.showFilters = !this.showFilters;
            if (this.showFilters) {
                element.addClass('open');
                if (this.isFixed) {
                    angular.element(document.getElementsByTagName('body')).css({'overflow': 'hidden'});
                }
            } else {
                element.removeClass('open');
                angular.element(document.getElementsByTagName('body')).css({'overflow': null});
                recalculate();
            }
        });

        const recalculate = () => {
            if (element.hasClass('open')) {
                return;
            }
            let elementBBox = element[0].getBoundingClientRect();
            if (elementBBox.bottom < 0 && !this.isFixed) {
                // To fixed
                this.isTransition = true;
                this.isFixed = true;
                wrapper.addClass('container-xl');
                element.addClass('fixed');
                element.css('min-height', `${elementBBox.height}px`);
                wrapper.css({'transform': `translateY(-100%)`});
                if (timeoutPromise) {
                    this.$timeout.cancel(timeoutPromise);
                }
                timeoutPromise = this.$timeout(() => {
                    this.isTransition = false;
                    wrapper.css({'transition': 'all .3s'});
                    wrapper.css({'transform': `translateY(0)`});
                }, 100);
            } else if (elementBBox.bottom > 0 && this.isFixed) {
                // To static
                this.isTransition = true;
                this.isFixed = false;
                wrapper.css({'transform': `translateY(-100%)`});
                if (timeoutPromise) {
                    this.$timeout.cancel(timeoutPromise);
                }
                timeoutPromise = this.$timeout(() => {
                    this.isTransition = false;
                    element.removeClass('fixed');
                    wrapper.css({'transform': null});
                    wrapper.css({'transition': null});
                    wrapper.removeClass('container-xl');
                }, 100);
            }
        }

        angular.element(this.$window).on('scroll', () => {
            recalculate();
        });
    }

    toFixed() {

    }

    static directiveFactory($window, $document, $timeout, $rootScope) {
        'ngInject';
        return new FixedFiltersDirective($window, $document, $timeout, $rootScope);
    }
}

export default FixedFiltersDirective;
